import { Box, Button, colors, FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { computeScale } from "../../../constants/utils";
import { GameContext, IGameContext } from "../../../contexts/GameContext";
import AnimationPlayer from "../Results/AnimationPlayer";
import ComfortBar from "../Results/ComfortBar";
import QualityBar from "../Results/QualityBar";
import { computeFinalAvg, computeFinalCumulAvg, computeFinalScore } from "../../../interface/Util";
import { AppContext } from "../../../contexts/AppContext";
import { setStyle } from "../../../util";
import FinalScore from "../End/FinalScore";
import { ResultsService } from "../../../services/results/ResultsService";
import { GameState } from "../../../interface/GameState";

interface IProps {
  resultId:string|null
}

const Reward = ({resultId}:IProps) => {
  const { finalScores, setGameState } = useContext<IGameContext>(GameContext);

  const { defaultValues, jwtToken, setStore, store } = useContext(AppContext);

  const [error, setError] = useState<String>("")
  const [exhausted, setExhausted] = useState<boolean>(false)

  useEffect(() => {
      if (defaultValues) setStyle(defaultValues);
  })

  useEffect(() => {
    if (!jwtToken) {
      console.log("[GiftCard] no jwtToken yet, skipping availability check");
      return;
    }
    console.log("[GiftCard] fetching /api/game/reward/availability");
    ResultsService.getRewardAvailability(jwtToken)
      .then((res) => {
        console.log("[GiftCard] availability response:", res?.data);
        const isExhausted = Boolean(res?.data?.exhausted);
        console.log(
          `[GiftCard] claimed=${res?.data?.claimed} limit=${res?.data?.limit} exhausted=${isExhausted} → ${isExhausted ? "hide radio" : "show radio"}`
        );
        setExhausted(isExhausted);
      })
      .catch((err) => {
        console.error("[GiftCard] availability fetch FAILED — defaulting to exhausted=false (radio will show)", err);
        setExhausted(false);
      });
  }, [jwtToken])


  const handleConfirm = async ()=>{
    if (jwtToken && resultId) {
      if (exhausted) {
        setError("")
        await ResultsService.sendReward(jwtToken, {resultId})
        setGameState(GameState.THANK_YOU)
        return
      }
      if(store!=""){
        setError("")
        await ResultsService.sendReward(jwtToken, {store:store,resultId:resultId})
        setGameState(GameState.THANK_YOU)
      }else{
        setError("Vous devez selectionner une carte")
      }

    }
  }
  
  return (
    <Container className="wrapper-resultat final-results">
      <Box className="wrapper-top-panel">
        <Box className="container-top">
          <Box className="container-top-left">
            <Typography sx={{ m: 4, fontWeight: 'bold' }} variant="h5">Résultats du jeu</Typography>
          </Box>
          <Box className="container-top-right">
            <Box className="box-result">
              <Box className="container-result">
               <FinalScore finalScore={computeFinalScore(finalScores)} scores={finalScores} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Body className="container-resultat">

        <MainWindow className="main-resultat">
            {exhausted ? (
              <>
                <Box sx={{width:"100%"}}>
                    <Typography>Merci d’avoir complété la simulation !</Typography>
                    <Typography>Votre participation est précieuse et contribue directement à notre projet.</Typography>
                </Box>
                <Box sx={{margin:"1rem auto"}}>
                    <Typography sx={{fontWeight:"bold"}}>
                        Toutes les cartes cadeau prévues pour cette étude ont déjà été distribuées.
                        Aucune carte cadeau ne pourra vous être attribuée, mais votre simulation est tout de même enregistrée.
                        Merci de votre participation !
                    </Typography>
                </Box>
              </>
            ) : (
              <>
                <Box sx={{width:"100%"}}>
                    <Typography>Merci d’avoir complété la simulation !</Typography>
                    <Typography>Votre participation est précieuse et contribue directement à notre projet.</Typography>
                    <Typography sx={{height:"fit-content"}}>En guise de remerciement, vous êtes éligible à recevoir une carte cadeau de 25 $ auprès de l’un des détaillants suivants :</Typography>
                </Box>

                <Box sx={{display:"block", margin:"1rem auto"}}>
                    <RadioGroup onChange={(event:any)=>{setStore((event.target as HTMLInputElement).value)}}>
                        <FormControlLabel value={"WALMART"} control={<Radio />} label="Walmart" />
                        <FormControlLabel value={"IGA"} control={<Radio />}  label="IGA" />
                        <FormControlLabel value={"MAXI"} control={<Radio />} label="Maxi" />
                    </RadioGroup>
                    <Typography sx={{color:"red"}}>{error}</Typography>
                </Box>

                <Box sx={{width:"100%"}}>
                    <Typography>Vous recevrez votre carte cadeau dans les 30 jours suivant la fin de la simulation.</Typography>
                    <Typography>La carte cadeau est offerte une seule fois par participant. Vous pouvez refaire la simulation autant de fois que vous le souhaitez, mais une seule carte cadeau pourra vous être attribuée.</Typography>
                </Box>
              </>
            )}

                                
        </MainWindow>

        <Stack className="container-analysis">
          {/*
          <Analysis values={values} points={points} finalScores={finalScores} />
          */}
          <Button variant="contained" onClick={()=>{handleConfirm()}}>Confirmer</Button>
        </Stack>

      </Body>
    </Container>
  );
};


const Container = styled.div`
`;


const Body = styled.div`
    display: flex;
`


const MainWindow = styled.div`
`;

const Title = styled.div`
    display: flex;
    color: white;
    padding: .5em;
`;

const Row = styled.div`
    display: flex;
`;

const StatBox = styled.div`
    
`;


export default Reward;